import React from "react";
// used for making the prop types of this component
import PropTypes from "prop-types";

// core components
import Button from "components/CustomButtons/Button.jsx";

import defaultImage from "assets/img/image_placeholder.jpg";
import defaultAvatar from "assets/img/placeholder.jpg";
import placeHolder_1 from "assets/img/placeholder_1.jpg";
import placeHolder_2 from "assets/img/placeholder_2.jpg";
import placeHolder_3 from "assets/img/placeholder_3.jpg";

class ImageUpload extends React.Component {
  constructor(props) {
    super(props);
    var imagePreview = placeHolder_1;
    if (props.ad_space === "2" || props.ad_space === "3") {
      imagePreview = placeHolder_2;
    }
    if (props.ad_space === "4" || props.ad_space === "5") {
      imagePreview = placeHolder_3;
    }
    this.state = {
      file: null,
      imagePreviewUrl: this.props.avatar ? defaultAvatar : imagePreview
    };
    this.handleImageChange = this.handleImageChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
  }
  componentDidMount() {
    const { adData, update } = this.props;
    if (update) {
      this.setState({
        imagePreviewUrl: adData.data.image_url
      });
    }
  }
  handleImageChange(e) {
    e.preventDefault();
    let reader = new FileReader();
    let file = e.target.files[0];
    reader.onloadend = () => {
      let image = new Image();
      image.src = reader.result;
      image.onload = () => {
        if (
          image.height !== this.props.requiredHeight ||
          image.width !== this.props.requiredWidth
        ) {
          this.props.handleWrongImage(
            this.props.requiredWidth,
            this.props.requiredHeight
          );
        } else {
          this.setState({
            file: file,
            imagePreviewUrl: reader.result
          });
        }
      };
    };
    reader.readAsDataURL(file);
    this.props.handleImageChange(file);
  }
  handleSubmit(e) {
    e.preventDefault();
    // this.state.file is the file/image uploaded
    // in this function you can save the image (this.state.file) on form submit
    // you have to call it yourself
  }
  handleClick() {
    this.refs.fileInput.click();
  }
  handleRemove() {
    const { adData, update } = this.props;
    if (update && this.state.imagePreviewUrl === adData.data.image_url) {
      this.setState({
        file: null,
        imagePreviewUrl: this.props.avatar ? defaultAvatar : defaultImage
      });
    } else {
      this.setState({
        file: null,
        imagePreviewUrl: this.props.avatar ? defaultAvatar : defaultImage
      });
    }
    this.refs.fileInput.value = null;
    this.props.handleImageChange(null);
  }
  render() {
    var {
      avatar,
      addButtonProps,
      changeButtonProps,
      // removeButtonProps,
      requiredWidth,
      requiredHeight
    } = this.props;
    return (
      <div className="fileinput text-center">
        <input type="file" onChange={this.handleImageChange} ref="fileInput" />
        <h4>{requiredWidth + "x" + requiredHeight}</h4>
        <div className={"thumbnail" + (avatar ? " img-circle" : "")}>
          <img src={this.state.imagePreviewUrl} alt="..." />
        </div>
        <div>
          {this.state.file === null && this.state.imagePreviewUrl === "" ? (
            <Button {...addButtonProps} onClick={() => this.handleClick()}>
              {avatar ? "Add Photo" : "Select image"}
            </Button>
          ) : (
            <span>
              <Button {...changeButtonProps} onClick={() => this.handleClick()}>
                Change
              </Button>
              {avatar ? <br /> : null}
              {/* <Button
                {...removeButtonProps}
                onClick={() => this.handleRemove()}
              >
                <i className="fas fa-times" /> Remove
              </Button> */}
            </span>
          )}
        </div>
      </div>
    );
  }
}

ImageUpload.propTypes = {
  avatar: PropTypes.bool,
  addButtonProps: PropTypes.object,
  changeButtonProps: PropTypes.object,
  removeButtonProps: PropTypes.object,
  adData: PropTypes.object,
  update: PropTypes.bool,
  handleImageChange: PropTypes.func
};

export default ImageUpload;



// WEBPACK FOOTER //
// ./src/components/CustomUpload/ImageUpload.jsx